import { render, staticRenderFns } from "./LayawaySales.vue?vue&type=template&id=167142ac&scoped=true"
import script from "./LayawaySales.vue?vue&type=script&lang=js"
export * from "./LayawaySales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167142ac",
  null
  
)

export default component.exports